(function($){
    $(function(){  
       var model,category ;
       $('#fast-model').on('change', function() {
          model = this.value;
         if (model.indexOf('&') > -1)
          {
            model = model.replace("&", "%26");
          }
           $("#quicksearch").attr("href", window.location.origin+'/collections/all?gf_475755='+model);//this will get value of input type is radio and name is pop_gender which was last time clicked //in side of function               
      });
       $('#fast-category').on('change', function() {
          category = this.value; 
           console.log(model,category);
         $("#quicksearch").attr("href", window.location.origin+'/collections/all?gf_475755='+model+'&gf_475753='+category); //this will get value of input type is radio and name is pop_gender which was last time clicked //in side of function               
       });
    });

})(jQuery);
